import React from "react"

import classNames from "classnames"

import { Obj, connect } from "scrivito"
import { ProductAttributes } from "scrivito/Objs/Product/ProductObjClass"
import { ProductAddonAttributes } from "scrivito/Objs/ProductAddon/ProductAddonObjClass"
import { ProductBaseVariantAttributes } from "scrivito/Objs/ProductBaseVariant/ProductBaseVariantObjClass"
import { ScrivitoImageWidgetList } from "scrivito/scrivito-image/ScrivitoImageWidgetList"

export interface ProductImageProps {
  obj:
    | Obj<
        | ProductAttributes
        | ProductAddonAttributes
        | ProductBaseVariantAttributes
      >
    | null
    | undefined
  isLoading?: boolean
  className?: string
}

function ProductImageComponent({ obj, className }: ProductImageProps) {
  return (
    <ScrivitoImageWidgetList
      key={obj?.id()}
      className={classNames("product-image", className)}
      content={obj as Obj}
      attribute="imageWidgets"
    />
  )
}

export const ProductImage = React.memo(connect(ProductImageComponent))
